import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './components/layouts/navbar/navbar.component';
import { PreloaderComponent } from './components/layouts/preloader/preloader.component';
import { HomeOneComponent } from './components/pages/home-one/home-one.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { AboutComponent } from './components/pages/about/about.component';
import { ContactComponent } from './components/pages/contact/contact.component';
import { VideoListComponent } from './components/pages/video-list/video-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductDetailsComponent } from './components/pages/product-details/product-details.component';
import { TeamDetailsComponent } from './components/pages/team-details/team-details.component';
import { SafeUrlPipe } from './pipe/safe-url.pipe';
import { VideoOverlayComponent } from './components/common/video-overlay/video-overlay.component';
import { CareerComponent } from './components/pages/career/career.component';
import { NewsComponent } from './components/pages/news/news.component';
import { NewsDetailsComponent } from './components/pages/news-details/news-details.component';
import { PrivacyComponent } from './components/pages/privacy/privacy.component';
import { TermsComponent } from './components/pages/terms/terms.component';
import { ProductListComponent } from './components/pages/product-list/product-list.component';
import { ClientListComponent } from './components/pages/client-list/client-list.component';
import { CustomerSatisfactionComponent } from './components/pages/customer-satisfaction/customer-satisfaction.component';
import { CustomerTestimonialComponent } from './components/pages/customer-testimonial/customer-testimonial.component';

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    PreloaderComponent,
    HomeOneComponent,
    FooterComponent,
    AboutComponent,
    TeamDetailsComponent,
    ContactComponent,
    VideoListComponent,
    ProductListComponent,
    ProductDetailsComponent,
    VideoOverlayComponent,
    CareerComponent,
    NewsComponent,
    NewsDetailsComponent,
    PrivacyComponent,
    TermsComponent,
    ClientListComponent,
    CustomerSatisfactionComponent,
    CustomerTestimonialComponent,
    SafeUrlPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
